module.exports = __webpack_public_path__ + "img/接口服务.801f9409.gif";